export default __webpack_public_path__ + "static/media/Esports.b2844e79.png";